import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useStrictLocalization } from "@faire/web--source/common/localization/localize";
import { Button } from "@faire/web--source/slate/Button";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { observer } from "mobx-react";
import React, { Suspense } from "react";
import { LazyPhoneInput } from "@faire/retailer-visitor-shared/components/PhoneInput/LazyPhoneInput";
import { useAppDownloadState } from "@faire/retailer-visitor-shared/components/MobileAppPromoBanner/AppDownloadState";
import { ViewAppLink } from "@faire/retailer-visitor-shared/components/MobileAppPromoBanner/ViewAppLink";
var TextAppSectionBase = function(param) {
    var eventPrefix = param.eventPrefix, appModalType = param.appModalType, onClose = param.onClose, loggedOut = param.loggedOut;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useAppDownloadState = useAppDownloadState(onClose, loggedOut), isInvalidPhoneNumber = _useAppDownloadState.isInvalidPhoneNumber, setPhoneNumber = _useAppDownloadState.setPhoneNumber, phoneNumber = _useAppDownloadState.phoneNumber, sendAppLink = _useAppDownloadState.sendAppLink;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraphSansRegular",
                align: loggedOut ? "left" : "center",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "/dCmFa",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Enter your phone number below and we\u2019ll text you a link to download the app."
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsx("div", {
                style: {
                    alignSelf: "stretch"
                },
                children: /*#__PURE__*/ _jsx(Suspense, {
                    fallback: null,
                    children: /*#__PURE__*/ _jsx(LazyPhoneInput, {
                        label: strictLocalize({
                            id: "hvvvVI",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Phone Number"
                                }
                            ]
                        }),
                        helper: strictLocalize({
                            id: "ZnfaeA",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Standard messaging rates apply"
                                }
                            ]
                        }),
                        error: isInvalidPhoneNumber ? strictLocalize({
                            id: "FPcbu0",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Please enter a valid phone number"
                                }
                            ]
                        }) : undefined,
                        onChangePhoneNumber: setPhoneNumber,
                        defaultPhoneNumber: phoneNumber
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsx(Button, {
                onClick: function() {
                    return sendAppLink("".concat(eventPrefix, "/app-modal"));
                },
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "vzUnMe",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Send Download Link"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            appModalType ? /*#__PURE__*/ _jsx(ViewAppLink, {
                appModalType: appModalType,
                eventPrefix: eventPrefix
            }) : null
        ]
    });
};
export var TextAppSection = observer(TextAppSectionBase);
